<ul class="list-group shadow-sm" [class.opacity-50]="loading" [class.disabled]="loading">
    @for (item of items; track $index; let idx = $index) {
    @if (deletingItemIndex === idx && loading) {
    <li class="list-group-item">
        <div class="row py-3">
            <div class="placeholder-wave col"><span class="placeholder col-8"></span></div>
            <div class="placeholder-wave col"><span class="placeholder col-8"></span></div>
            <div class="placeholder-wave col"><span class="placeholder col-12"></span></div>
            <div class="placeholder-wave col text-end pe-4">
                <button class="qai-list-action-button" disabled>
                    <fa-icon [icon]="faTrash"></fa-icon>
                </button>
            </div>
        </div>
    </li>
    } @else {
    <button class="list-group-item list-group-item-action" (click)="rowClick.emit(item)">
        <div class="row py-3">
            @for (column of columns; track $index) {
            <div class="col text-start">{{ item[column] }}</div>
            }
            <div class="col text-end pe-4">
                <button class="qai-list-action-button" (click)="deleteItem(item, idx); $event.stopPropagation()" [disabled]="loading">
                    <fa-icon [icon]="faTrash"></fa-icon>
                </button>
            </div>
        </div>
    </button>
    }
    }
    @if (deletingItemIndex === null && loading) {
    <li class="list-group-item">
        <div class="row py-3">
            <div class="placeholder-wave col"><span class="placeholder col-8"></span></div>
            <div class="placeholder-wave col"><span class="placeholder col-8"></span></div>
            <div class="placeholder-wave col"><span class="placeholder col-12"></span></div>
            <div class="placeholder-wave col text-end pe-4">
                <button class="qai-list-action-button" disabled>
                    <fa-icon [icon]="faTrash"></fa-icon>
                </button>
            </div>
        </div>
    </li>
    }
</ul>